import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { formatHighlightedText } from '@/lib/utils';

export default function HeroBoxLinks({ block, position }) {
  const { uid, eyebrow, headline, links, secondary_text_color } =
    block.hero_box_links.reference[0];

  return (
    <section id={`${uid}_${position}`} data-name={'hero-box-links'}>
      <div className="mx-0 flex w-full min-w-sm flex-col items-center justify-center px-5 py-15 sm:items-start sm:px-20 sm:py-20 lg:mx-auto lg:max-w-7xl lg:flex-row lg:items-center lg:justify-between lg:gap-4.5 lg:px-20 lg:py-15">
        <div className="flex w-full flex-col items-start gap-4 sm:max-w-sm lg:max-w-md">
          {eyebrow && (
            <div className="lg:preheading-r preheading-s">{eyebrow}</div>
          )}
          <h1 className="lg:h1 sm:h2 h3">
            {headline &&
              formatHighlightedText(headline, { color: secondary_text_color })}
          </h1>
        </div>
        <div className="flex w-full items-center justify-center gap-5 pt-10 sm:items-start sm:justify-start lg:ml-10 lg:max-w-xl lg:items-center lg:justify-center">
          {links &&
            links.map((link, index) => {
              const {
                global_field: { internal_link, label },
                image
              } = link;
              return (
                <div
                  key={index}
                  className="flex flex-1 flex-col items-center justify-center gap-2.5 self-stretch"
                >
                  <Link href={internal_link[0].url} prefetch={false}>
                    <div className="flex aspect-[4/4.25] w-full items-end justify-center gap-2.5 self-stretch sm:aspect-auto sm:h-70 lg:h-78 lg:w-72.5">
                      <Image
                        alt={image.title}
                        src={image.url}
                        width={320}
                        height={402}
                        className="h-full w-full object-cover object-center"
                      />
                    </div>
                    {label && (
                      <div className="lg:h5 h6 flex items-center gap-2.5 self-stretch pt-2 whitespace-nowrap">
                        <span className="txt-btn-secondary">{label}</span>
                        <SvgGoArrow />
                      </div>
                    )}
                  </Link>
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
}

function SvgGoArrow() {
  return (
    <svg
      enableBackground="new 0 0 24 24"
      height="24"
      width="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2.5 self-center"
      aria-hidden="true"
    >
      <g
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m3 12h18" />
        <path d="m16 7 5 5-5 5" />
      </g>
    </svg>
  );
}
